module.exports = __webpack_public_path__ + "img/product-2.0f8eacfd.svg";